import { useContext } from "react";
import { AuthServiceContext } from "./AuthServiceContext";
import AuthService from "./models/AuthService";

export const useAuth = (): AuthService => {
  const context = useContext(AuthServiceContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
